import SurveyItem from "./SurveyItem";

export default SurveyItem;
